function windAnimationDirection(offshoreness) {
  switch (offshoreness) {
    case 'on':
      return 90;
    case 'off':
      return -90;
    case 'cross':
      return 360;
    case 'cross-off':
      return -45;
    case 'cross-on':
      return 45;
    default:
      return 0;
  }
}

export default windAnimationDirection;
